/**
 * /podbor-firmy/ quiz (port of filter_firm.js): each step narrows the firm list
 * embedded as JSON (#podbor-data); the count and the chosen answers go into the request form.
 */
type Firm = { name: string; tax: string; sro: string; text: string; turnover: string; year: string; lic: string }

const decl = (n: number, words: [string, string, string]) =>
  words[n % 100 > 4 && n % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][n % 10 < 5 ? Math.abs(n) % 10 : 5]]

const matches = (firm: Firm, step: string, value: string) => {
  const year = new Date().getFullYear()
  switch (step) {
    case 'name':
      if (value === 'Не важно') return true
      if (value === 'Другое') return !firm.name.includes('ООО') && !firm.name.includes('ПАО')
      return firm.name.includes(value)
    case 'tax':
      if (value === 'Другое') return !firm.tax.includes('УСН') && !firm.tax.includes('ОСН')
      return firm.tax.includes(value)
    case 'turnover':
      return value === 'Не важно' || firm.turnover.includes(value)
    case 'year':
      if (value === 'Не важно') return true
      if (value === String(year)) return firm.year.includes(value)
      return Number(firm.year) <= year - Number(value)
    case 'lic|sro':
      if (value === 'С лицензией') return firm.lic !== 'false'
      if (value === 'С допуском СРО') return firm.sro !== 'false'
      return firm.lic === 'false' && firm.sro === 'false'
    case 'text':
      if (value === 'Есть') return firm.text !== ''
      if (value === 'Нет') return firm.text === ''
      return true
    default:
      return true
  }
}

export function initPodbor() {
  const data = document.getElementById('podbor-data')
  if (!data) return
  const firms = JSON.parse(data.textContent || '[]') as Firm[]
  const counter = document.querySelector<HTMLElement>('.firm_result_span')
  const setWord = (n: number) =>
    document.querySelectorAll<HTMLElement>('.firm_result_firm').forEach((el) => (el.textContent = n ? decl(n, ['фирма!', 'фирмы!', 'фирм!']) : 'фирм'))
  setWord(firms.length)

  const animate = (to: number) => {
    if (!counter) return
    const from = Number(counter.textContent) || 0
    const start = performance.now()
    const tick = (t: number) => {
      const k = Math.min(1, (t - start) / 1000)
      counter.textContent = String(Math.ceil(from + (to - from) * k))
      if (k < 1) requestAnimationFrame(tick)
    }
    requestAnimationFrame(tick)
  }

  document.addEventListener('click', (e) => {
    const btn = (e.target as HTMLElement).closest<HTMLElement>('.btn-border')
    if (!btn) return
    const step = btn.closest<HTMLElement>('.step')
    step?.querySelectorAll('.btn-border').forEach((b) => b.classList.toggle('btn-border-active', b === btn))

    const chosen = Array.from(document.querySelectorAll<HTMLElement>('.step'))
      .map((s) => ({ step: s.dataset.value ?? '', value: s.querySelector('.btn-border-active')?.getAttribute('value') ?? '' }))
      .filter((c) => c.value)
    const result = firms.filter((f) => chosen.every((c) => matches(f, c.step, c.value)))

    document.querySelector('.firm_zapros_1')?.classList.toggle('display_none', result.length > 0)
    document.querySelector('.firm_zapros_2')?.classList.toggle('display_none', result.length === 0)
    if (result.length) setWord(result.length)
    animate(result.length)

    const answers = Array.from(document.querySelectorAll<HTMLElement>('.step-descr'))
      .map((d, i) => `\n-${d.innerText} ${document.querySelectorAll('.step-options')[i]?.querySelector('.btn-border-active')?.textContent ?? ''}; `)
      .join('')
    document.querySelectorAll<HTMLInputElement>('.btns_clicked_podbor').forEach((i) => (i.value = answers))
    document.querySelectorAll<HTMLInputElement>('.firms_podbor').forEach((i) => (i.value = result.map((f) => `\n-${f.name}; `).join('')))
  })

  const thanks = document.querySelector<HTMLElement>('.form_thx')
  document.addEventListener('wpcf7mailsent', () => {
    if (thanks) thanks.style.display = 'block'
  })
  document.querySelectorAll('.btns_thx_wrap button').forEach((b) => b.addEventListener('click', () => thanks && (thanks.style.display = 'none')))
}
